<template>
  <div id="header" class="clearfix" v-if="headerIsShow">
    <!-- <router-link to="/" class="tohomepage">返回</router-link> -->
    <!-- <a href="javascript:;" @click="goBack" class="tohomepage">‹</a> -->
    <div class="tohomepage" @click="goBack">
      <img src="../../assets/img/back.png" />
    </div>
    <span class="examplename">{{examplename}}</span>
    <!-- <a href="javascript:;" @click="goBack" class="goback">返回</a> -->
  </div>
</template>
<script>
export default {
  name: "G-header",
  data() {
    return {
      msg: "页面顶部"
    };
  },
  props: {
    headerIsShow: {
      type: Boolean,
      default: true
    },
    examplename: {
      type: String,
      default: ""
    }
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.replace("/");
    }
  }
};
</script>
<style lang="less">
#header {
  background: #f8f8f8;
  border-bottom: 1px solid #ccc;
  text-align: center;
  .tohomepage {
    height: 100%;
    line-height: 40px;
    padding: 0 5px;
    position: absolute;
    left: 10px;
    display: flex;
    align-content: center;
    align-items: center;
    > img {
      height: 18px;
    }
  }
  .examplename {
    color: #333;
    font-size: 15px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GlobleHeader/index.vue